// Static product catalog. Images are served from /public/images/products/ —
// no backend, no external CDN. 100% self-contained.

const PRODUCTS = [
  {
    id: "ssm-the-classic-tshirt",
    slug: "the-classic-tshirt",
    name: "The Classic T-Shirt",
    price: 29.0,
    color: "black",
    category: "t-shirts",
    gender: "men",
    sizes: ["S", "M", "L", "XL"],
    short_description: "A clean, comfortable everyday tee. Available in black and white.",
    description:
      "A soft cotton t-shirt with a regular fit that works for any day. Comfortable to wear, easy to pair with anything, and built to hold its shape wash after wash. Shown in black and white. A true wardrobe essential.",
    colorVariants: [
      {
        name: "Black",
        hex: "#111111",
        images: [
          "/images/products/tshirt-black-front.png",
          "/images/products/tshirt-black-back.png",
        ],
      },
      {
        name: "White",
        hex: "#f5f5f0",
        images: [
          "/images/products/tshirt-white-front.png",
          "/images/products/tshirt-white-back.png",
        ],
      },
    ],
    images: [
      "/images/products/tshirt-black-front.png",
      "/images/products/tshirt-black-back.png",
      "/images/products/tshirt-white-front.png",
      "/images/products/tshirt-white-back.png",
    ],
    featured: true,
  },
  {
    id: "ssm-the-hoodie",
    slug: "the-hoodie",
    name: "The Hoodie",
    price: 89.0,
    color: "black",
    category: "hoodies",
    gender: "men",
    sizes: ["S", "M", "L", "XL"],
    short_description: "A warm, heavyweight hoodie. Available in black, grey, and white.",
    description:
      "A dense cotton hoodie with a relaxed fit and a brushed inside for extra warmth. Ribbed cuffs and hem keep their shape over time, so it looks as good after a year as it does today. Shown in black, grey, and white. Designed for comfort and everyday wear.",
    colorVariants: [
      {
        name: "Black",
        hex: "#111111",
        images: [
          "/images/products/hoodie-black-front.png",
          "/images/products/hoodie-black-back.png",
        ],
      },
      {
        name: "Grey",
        hex: "#9ca3af",
        images: [
          "/images/products/hoodie-grey-front.png",
          "/images/products/hoodie-grey-back.png",
        ],
      },
      {
        name: "White",
        hex: "#f5f5f0",
        images: [
          "/images/products/hoodie-white-front.png",
          "/images/products/hoodie-white-back.png",
        ],
      },
    ],
    images: [
      "/images/products/hoodie-black-front.png",
      "/images/products/hoodie-black-back.png",
      "/images/products/hoodie-grey-front.png",
      "/images/products/hoodie-grey-back.png",
      "/images/products/hoodie-white-front.png",
      "/images/products/hoodie-white-back.png",
    ],
    featured: true,
  },
  {
    id: "ssm-the-sweatshirt",
    slug: "the-sweatshirt",
    name: "The Sweatshirt",
    price: 69.0,
    color: "black",
    category: "sweatshirts",
    gender: "women",
    sizes: ["S", "M", "L", "XL"],
    short_description: "A soft, slightly oversized crewneck. Available in black and white.",
    description:
      "A comfortable cotton sweatshirt with a slightly oversized fit for an easy, modern silhouette. Made from a durable fabric that stays soft and holds its shape wash after wash. Shown in black and white. A simple layer you'll reach for every week.",
    colorVariants: [
      {
        name: "Black",
        hex: "#111111",
        images: [
          "/images/products/sweatshirt-black-front.png",
          "/images/products/sweatshirt-black-back.png",
        ],
      },
      {
        name: "White",
        hex: "#f5f5f0",
        images: [
          "/images/products/sweatshirt-white-front.png",
          "/images/products/sweatshirt-white-back.png",
        ],
      },
    ],
    images: [
      "/images/products/sweatshirt-black-front.png",
      "/images/products/sweatshirt-black-back.png",
      "/images/products/sweatshirt-white-front.png",
      "/images/products/sweatshirt-white-back.png",
    ],
    featured: true,
  },
  {
    id: "ssm-the-semi-slim-jeans",
    slug: "the-semi-slim-jeans",
    name: "The Semi-Slim Jeans",
    price: 109.0,
    color: "blue",
    category: "jeans",
    gender: "men",
    sizes: ["S", "M", "L", "XL"],
    short_description: "A refined semi-slim denim with real comfort.",
    description:
      "A classic five-pocket jean with a semi-slim cut that follows the leg without hugging it. A touch of stretch for comfort, deep pockets for daily use, and a timeless mid-blue wash. Easy to wear, built to last.",
    images: [],
    comingSoon: true,
    featured: true,
  },
  {
    id: "ssm-the-denim-shirt",
    slug: "the-denim-shirt",
    name: "The Denim Shirt",
    price: 85.0,
    color: "blue",
    category: "shirts",
    gender: "men",
    sizes: ["S", "M", "L", "XL"],
    short_description: "A clean denim shirt with a simple, timeless cut.",
    description:
      "A soft denim shirt with a classic fit and a clean finish — no visible branding, just the essentials. Comfortable enough to wear open over a tee or buttoned up on its own. A versatile piece for any season.",
    images: [
      "/images/products/denim-shirt-front.png",
      "/images/products/denim-shirt-back.png",
    ],
    featured: true,
  },
  {
    id: "ssm-the-classic-sweater",
    slug: "the-classic-sweater",
    name: "The Classic Sweater",
    price: 109.0,
    color: "camel",
    category: "sweaters",
    gender: "women",
    sizes: ["S", "M", "L", "XL"],
    short_description: "A soft, warm sweater in a warm camel tone.",
    description:
      "A soft sweater with a classic crewneck cut and a relaxed fit. Warm enough for cold days, soft against the skin, and easy to care for. A simple staple that pairs with everything.",
    images: [],
    comingSoon: true,
    featured: true,
  },
];

export default PRODUCTS;
